(() => {
  const updateVariantPrice = (variant) => {
    if (!variant) return;

    document.querySelectorAll('[data-anatai-price-root]').forEach((root) => {
      const productBlock = root.closest('.product__block--product-header-inner');
      const dataNode = productBlock?.querySelector('[data-anatai-variant-prices]');
      if (!dataNode) return;

      let prices;
      try {
        prices = JSON.parse(dataNode.textContent);
      } catch (_) {
        return;
      }

      const selected = prices[String(variant.id)];
      if (!selected) return;

      const price = root.querySelector('[data-price]');
      const comparePrice = root.querySelector('[data-compare-price]');
      if (price) price.textContent = selected.discounted;
      if (comparePrice) comparePrice.textContent = selected.regular;
    });
  };

  document.addEventListener('product:variant-change', (event) => {
    updateVariantPrice(event.detail?.variant);
  });
})();
